import { round } from 'lodash';

// correct js multipliers
// ex: v1 = 12, v2 = 1.12
// (12 * 1000) * (1.12 * 100) / (1000 * 100) = 12 * 112 / 100000 = 1369 / 100000 = 13.69
const multiply = (v1: number, v2: number) => {
  const countDecimals1 = v1.toString().split('.')[1]?.length || 0;
  const countDecimals2 = v2.toString().split('.')[1]?.length || 0;

  const correctMultiplier1 = countDecimals1 ? Math.pow(10, countDecimals1) : 1;
  const correctMultiplier2 = countDecimals2 ? Math.pow(10, countDecimals2) : 1;

  // there will be only .00000001 or .999999
  const increasedV1 = Math.round(v1 * correctMultiplier1);
  const increasedV2 = Math.round(v2 * correctMultiplier2);

  return (
    (increasedV1 * increasedV2) / (correctMultiplier1 * correctMultiplier2)
  );
};

const getDecimalSafeValue = (value: number, precision = 2) => {
  return round(value, precision);
};

export { multiply, getDecimalSafeValue };
